(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
(function() {
  function initSlider(root) {
    const track = root.querySelector('[data-track]');
    const prevInternal = root.querySelector('[data-prev]');
    const nextInternal = root.querySelector('[data-next]');
    if (!track) return;

    const isRTL = getComputedStyle(document.documentElement).direction === 'rtl';
    const slideWidth = () => track.querySelector('.rp-slide')?.getBoundingClientRect().width || 0;

    function updateButtons(externals = []) {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const x = Math.abs(track.scrollLeft);
      const disablePrev = x <= 2;
      const disableNext = x >= maxScroll - 2;

      if (prevInternal) prevInternal.disabled = disablePrev;
      if (nextInternal) nextInternal.disabled = disableNext;
      externals.forEach(btn => {
        if (btn.hasAttribute('data-prev')) btn.disabled = disablePrev;
        if (btn.hasAttribute('data-next')) btn.disabled = disableNext;
      });
    }

    // ✅ Scroll by 3.5 slides per click
    function scrollBySlides(dir, externals = []) {
      const slide = slideWidth();
      const slidesToScroll = 4.5; // 👈 scroll this many slides each time
      const amount = slide * slidesToScroll;
      const delta = dir * amount * (isRTL ? -1 : 1);
      track.scrollBy({ left: delta, behavior: 'smooth' });
      setTimeout(() => updateButtons(externals), 400);
    }

    if (prevInternal) prevInternal.addEventListener('click', () => scrollBySlides(-1));
    if (nextInternal) nextInternal.addEventListener('click', () => scrollBySlides(1));
    track.addEventListener('scroll', () => updateButtons(), { passive: true });
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') scrollBySlides(-1);
      if (e.key === 'ArrowRight') scrollBySlides(1);
    });

    root._rp = { updateButtons, scrollBySlides };
    requestAnimationFrame(() => updateButtons());
  }

  function wireExternalButtons() {
    document.querySelectorAll('[data-for]').forEach(btn => {
      const targetId = btn.getAttribute('data-for');
      const root = document.getElementById(targetId);
      if (!root || !root._rp) return;

      const siblings = document.querySelectorAll(`[data-for="${CSS.escape(targetId)}"]`);
      const externals = Array.from(siblings);

      if (btn.hasAttribute('data-prev')) {
        btn.onclick = () => root._rp.scrollBySlides(-1, externals);
      }
      if (btn.hasAttribute('data-next')) {
        btn.onclick = () => root._rp.scrollBySlides(1, externals);
      }
      root._rp.updateButtons(externals);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-slider]').forEach(initSlider);
    setTimeout(wireExternalButtons, 0);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  // ✅ Observe all product-recommendations (for dynamic loading)
  function observeProductRecs() {
    document.querySelectorAll('product-recommendations').forEach(pr => {
      const mo = new MutationObserver(() => initAll());
      mo.observe(pr, { childList: true, subtree: true });
    });
  }
  observeProductRecs();

  // ✅ Theme Editor support
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
  document.addEventListener('shopify:section:deselect', initAll);
  document.addEventListener('shopify:block:select', initAll);
  document.addEventListener('shopify:block:deselect', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
